import useMembreAuth from "../../hooks/useMembreAuth";
import usePresenceHistory from "../../hooks/usePresenceHistory";

export default function History() {
  const { user, loading: authLoading } = useMembreAuth();
  const { history, loading } = usePresenceHistory();

  if (authLoading || loading) {
    return <p className="p-6">Chargement…</p>;
  }

  if (!user) return null;

  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h1 className="text-2xl font-bold mb-6">
        📅 Mon historique de présence
      </h1>

      {history.length === 0 && (
        <p className="text-gray-500">Aucune session enregistrée.</p>
      )}

      <div className="space-y-3">
        {history.map((p, i) => (
          <div
            key={i}
            className="p-4 bg-white rounded-xl shadow flex justify-between items-center"
          >
            <div>
              <p className="font-semibold text-blue-700">{p.date}</p>
              <p
                className={`text-sm font-bold ${
                  p.status === "present"
                    ? "text-green-600"
                    : "text-red-600"
                }`}
              >
                {p.status === "present" ? "Présent" : "Absent"}
              </p>
            </div>

            <span className="text-gray-800">
              {p.scanned_at
                ? new Date(p.scanned_at).toLocaleTimeString("fr-FR", {
                    hour: "2-digit",
                    minute: "2-digit",
                  })
                : "—"}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
